/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Settings_UsernameInputs */

const vi_smartlab_settings_username = /** @type {(inputs: Smartlab_Settings_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên đăng nhập`)
};

/**

* @param {Smartlab_Settings_UsernameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_settings_username = /** @type {((inputs?: Smartlab_Settings_UsernameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Settings_UsernameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_settings_username(inputs)
});